import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { Accordion as BootstrapAccordion } from 'react-bootstrap'
export { Toggle } from './Toggle'
export { Show } from './Show'
import { useDispatch } from 'react-redux'

import { actions } from '@/reducers/accordion'

const Accordion = ({ children, defaultActiveKey, noMargin }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.updateDefaultEventKey(defaultActiveKey))
  }, [])

  return (
    <BootstrapAccordion
      className={noMargin && 'no-margin'}
      {...{ children }}
    />
  )
}

Accordion.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  defaultActiveKey: PropTypes.string.isRequired,
  noMargin: PropTypes.bool
}

export default Accordion
